<template lang="pug">
  v-layout(row justify-center)
    v-flex(xs12)
      v-card-title(class="text-xs-center")
        h4.display-1 Сведения о выявленных семьях и детях, находящихся в трудной жизненной ситуации по ежемесячный период
      v-card-text
        v-layout(row justify-center)
          v-flex(xs12)
            table
              tr
                td(class="strong center pa-2", style="width: 5%") №
                td(class="strong center pa-2", style="width: 75%") Наименование категорий
                td(class="strong center pa-2", style="width: 20%") ежмесячный период
              tr
                td(class="strong pl-1 pa-1") 1
                td(class="strong pl-1 pa-1") Общее количество детей в районе/городе
                td(class="strong center") 1685
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 2
                td(class="bd-b-none pl-1 strong") Численность выявленных детей, из них:
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 49
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 87
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 29
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 44
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-b-none bd-t-none center") 78
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 3
                td(class="bd-b-none pl-1 strong") Численность детей, подвергшихся насилию, составленных на них ИПЗР, из них:
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 65
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 34
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 81
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 20
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-b-none bd-t-none center") 30
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 4
                td(class="bd-b-none pl-1 strong") Численность детей, подвергшихся физическому насилию, составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 24
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 70
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 91
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 80
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-b-none bd-t-none center") 7
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 5
                td(class="bd-b-none pl-1 strong") Численность детей, подвергшихся сексуальному насилию составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 60
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 58
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 85
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 67
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-b-none bd-t-none center") 54
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 6
                td(class="bd-b-none pl-1 strong") Численность детей, подвергшихся к психическому насилию составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 45
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 35
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 3
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 28
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-b-none bd-t-none center") 47
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 7
                td(class="bd-b-none pl-1 strong") Численность работающих детей, составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 16
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 36
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 22
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 40
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 21
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 8
                td(class="bd-b-none pl-1 strong")  Вовлеченных в наихудшие формы детского труда составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 39
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 27
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 98
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 56
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 2
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 9
                td(class="bd-b-none pl-1 strong")  Численность детей, находящихся в конфликте с законом (согласно данным РОВД) составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 62
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 17
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 79
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 48
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 12
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 10
                td(class="bd-b-none pl-1 strong")  Численность выявленных детей с ограниченными возможностями здоровья составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 37
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 19
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 43
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 12
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 29
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 11
                td(class="bd-b-none pl-1 strong")  Численность детей, оставленных без попечения родителей, из них
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 19
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 32
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 24
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 10
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 33
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 12
                td(class="bd-b-none pl-1 strong")  Численность беспризорных детей составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 27
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 20
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 29
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 23
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 11
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 13
                td(class="bd-b-none pl-1 strong")  Численность безнадзорных детей составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 9
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 38
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 23
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 41
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 2
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 14
                td(class="bd-b-none pl-1 strong")  Численность брошенных детей, согласно акта органа внутренних дел составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 11
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 50
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 35
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 42
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 28
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 15
                td(class="bd-b-none pl-1 strong")  Численность детей, родители которых  ограничены в родительских правах составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 3
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 22
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 14
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 49
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 16
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 16
                td(class="bd-b-none pl-1 strong")  Численность детей, родители которых лишены родительских прав (обоих родителей) составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 44
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 31
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 15
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 33
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 27
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 17
                td(class="bd-b-none pl-1 strong")  Численность детей, родители (или лиц их заменяющих) которых отбывают наказание в виде лишения свободы составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 31
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 27
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 24
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 33
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 27
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 18
                td(class="bd-b-none pl-1 strong")  Численность детей, родители которых признаны безвестно отсутствующими составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 15
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 8
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 25
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 42
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 2
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 19
                td(class="bd-b-none pl-1 strong")  Численность детей, родители которых признаны недееспособными составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 45
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 32
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 30
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 21
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 7
              tr
                td(rowspan="6" style="verticalAlign: top" class="pl-1") 20
                td(class="bd-b-none pl-1 strong")  Численность детей, родители которых уклоняются от воспитания и содержания ребенка, составленных на них ИПЗР
                td(class="bd-b-none center")
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: мальчик
                td(class="bd-b-none bd-t-none center") 34
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") девочка
                td(class="bd-b-none bd-t-none center") 5
              tr
                td(class="bd-b-none bd-t-none pl-1 font-italic") из них: от от 0 до 7лет
                td(class="bd-b-none bd-t-none center") 40
              tr
                td(class="bd-b-none bd-t-none pl-60 font-italic") от 7 до 14 лет
                td(class="bd-b-none bd-t-none center") 45
              tr
                td(class="bd-t-none pl-60 font-italic") от 14 до 18 лет
                td(class="bd-t-none center") 17

</template>

<script>
import Table from '../../OrganisationStructure/Division/DivisionList/common/Table'
export default {
  name: 'ReportTable',
  components: { Table },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  table {
    box-sizing: border-box;
    border-collapse: collapse;
    width: 100%;
    font-size: 16px;
    td {
      border: 1px solid #777;
    }
  }
  .bd-b-none {
    border-bottom: none;
  }
  .bd-t-none {
    border-top: none;
  }
  .strong {
    font-weight: 700;
  }
  .center {
    text-align: center;
  }
  .pl-60 {
    padding-left: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports/ReportTable/ReportTable.vue